/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';
import { connect } from 'react-redux';

import { UserData } from '../../../../models/UserModel';
import { TextLink } from '../../../components/TextLink';
import FlexRow from '../../../components/FlexRow';
import Spacer from '../../../components/Spacer';
import ReadOnlyInputRow from '../../../components/ReadOnlyInputRow';
import UserService from '../../../../apiServices/UserService';
import { actions as userActions } from '../../../redux/ducks/user';

interface Props {
  titlePhrase: any;
  userData: UserData;
  onCancel(): void;
  goToChangeEmail(): void;
  cancelPendingEmail(id): Promise<any>;
}

interface State {
  isSendingEmail: boolean;
}

class UnverifiedEmailControl extends React.Component<Props, State> {

  state: State = {
    isSendingEmail: false,
  };

  sendEmailTimer: any;

  componentWillUnmount() {
    this.clearEmailTimer();
  }

  clearEmailTimer = () => {
    if (this.sendEmailTimer) {
      clearTimeout(this.sendEmailTimer);
      this.sendEmailTimer = null;
    }
  }

  resendChangeEmailRequest = () => {
    const { isSendingEmail } = this.state;
    const { userData } = this.props;

    if (isSendingEmail) { return; }

    UserService.verifyEmail(userData.id);
    this.setState({ isSendingEmail: true });

    this.sendEmailTimer = setTimeout(() => {
      this.setState({ isSendingEmail: false });
      this.clearEmailTimer();
    }, 3000);
  }

  cancelPendingEmail = () => {
    const { userData, cancelPendingEmail } = this.props;
    cancelPendingEmail(userData.id).then(() => {
      this.resendChangeEmailRequest();
    });
  }

  render() {
    const { isSendingEmail } = this.state;
    const { userData, titlePhrase, goToChangeEmail } = this.props;

    const email = userData.pending_email || userData.email;
    const hasPendingEmail = !!userData.pending_email;
    const emailMessage = isSendingEmail ? 'verifyEmail.resendingEmail.button.label' : 'verifyEmail.resendEmail.button.label';
    const emailMessageFontStyle = isSendingEmail ? 'italic' : null;

    return (
      <div style={{ width: '100%' }}>
        <ReadOnlyInputRow
          title={titlePhrase.id}
          value={email}
          style={{ wordBreak: 'break-all' }}
        />

        <Spacer size="10" />

        <FlexRow style={{ justifyContent: 'space-between' }}>
          <TextLink style={{ fontStyle: emailMessageFontStyle }} className="font-footnote font-color-profile" onClick={this.resendChangeEmailRequest}>
            <FormattedMessage id={emailMessage} />
          </TextLink>

          {
            hasPendingEmail ? (
              <TextLink className="font-footnote font-color-gsMedDark" onClick={this.cancelPendingEmail}>
                <FormattedMessage id="verifyEmail.cancelPendingEmail.button.label" />
              </TextLink>
            ) : (
              <TextLink className="font-footnote font-color-gsMedDark" onClick={goToChangeEmail}>
                <FormattedMessage id="verifyEmail.changeEmail.button.label" />
              </TextLink>
            )
          }
        </FlexRow>
      </div>
    );
  }
}

export default connect(() => {
  return {};
}, (dispatch) => {
  return {
    cancelPendingEmail: (userId) => {
      return dispatch(userActions.cancelPendingEmail(userId));
    },
  };
})(UnverifiedEmailControl);
